import { MESSAGE } from "constants/validate";

export interface CategoryFormField {
  label: string;
  fieldName: keyof CategoryFormData;
  disabled?: boolean;
  type?: "text" | "select";
  rules?: any;
  options?: Array<{ label: string; value: any }>;
}

export type CategoryFormData = {
  id?: number;
  categoryCd: string;
  categoryKbnCd: string;
  categoryKbn: string;
  categoryName: string;
  seq: number;
  statusFlag: number;
  deleteFlag: number;
};

// Sequence options (1-10)
export const SEQUENCE_OPTIONS = Array.from({ length: 10 }, (_, i) => ({
  label: (i + 1).toString(),
  value: i + 1,
}));

// Status options
export const STATUS_OPTIONS = [
  { label: "有効", value: 1 },
  { label: "無効", value: 0 },
];

/**
 * Get category form fields configuration
 * @param isUpdate - Whether the form is in update mode
 * @returns Array of form field configurations
 */
export const getCategoryFormFields = (isUpdate: boolean): CategoryFormField[] => [
  {
    label: "分類コード",
    fieldName: "categoryCd",
    disabled: isUpdate,
    rules: isUpdate
      ? undefined
      : {
          required: MESSAGE.EMPTY,
          maxLength: {
            value: 50,
            message: MESSAGE.MAX_LENGTH(50),
          },
        },
  },
  {
    label: "区分コード",
    fieldName: "categoryKbnCd",
    rules: {
      required: MESSAGE.EMPTY,
      maxLength: {
        value: 10,
        message: MESSAGE.MAX_LENGTH(10),
      },
    },
  },
  {
    label: "区分名",
    fieldName: "categoryKbn",
    rules: {
      required: MESSAGE.EMPTY,
      maxLength: {
        value: 10,
        message: MESSAGE.MAX_LENGTH(10),
      },
    },
  },
  {
    label: "分類名",
    fieldName: "categoryName",
    rules: {
      required: MESSAGE.EMPTY,
      maxLength: {
        value: 100,
        message: MESSAGE.MAX_LENGTH(100),
      },
    },
  },
];
